import React from 'react'
import Modal from 'react-modal';

Modal.setAppElement('#root');
const ModalInfo = (props) => {

    const { data, onClose } = props

    return (
        <Modal
            isOpen={data.show}
            contentLabel=""
            className="modal-content modal-sm"
            overlayClassName="modal-overlay"
            onRequestClose={onClose}>
            <div className="p-2" style={{ minWidth: '300px' }}>
                <p className="card-title font-weight-bolder">{data.title}</p>
                {/* <h6 className="card-title">{data.title}</h6> */}
                <p className="small card-text text-break">{data.message}</p>

                <div className="nav justify-content-end">
                    <button onClick={onClose} className="btn btn-sm btn-app">Cerrar</button>
                </div>
            </div>
        </Modal>
    );
}

export default ModalInfo;